<template>
    <div>
        <v-layout v-if="$storeCandidature.sasCandidature.Ecole &&
                  ($storeCandidature.dataIdFormulaireCandidature == $storeCandidature.configurationClient.DescIdFormulaireBachelorsBba
                 || $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleIsbe)">
            <span class="red--text">
                <p v-if="$storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleIsbe" class="text-left">* MERCI DE COMPLÉTER L'ANNÉE EN COURS UNIQUEMENT et N-1 quand année de césure / reprise d’études</p>
                <p v-if="$storeCandidature.dataIdFormulaireCandidature == $storeCandidature.configurationClient.DescIdFormulaireBachelorsBba" class="text-left">* MERCI DE COMPLÉTER L'ANNÉE EN COURS ET L'ANNEE PRECEDENTE UNIQUEMENT</p>
            </span>
        </v-layout>
        <span v-if="$storeCandidature.configurationClient
              && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational
              && $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleIum">
            You can add up to one line per level of studies or diploma, starting from high school diploma year (or equivalent), by clicking the « Add » button on the right side of the following table
        </span>
        <v-layout row wrap xs12>
            <h3>
                {{$storeCandidature.langueFormulaire == 'en' ? 'My diplomas:' : 'Parcours Scolaire :'}}
            </h3>
            <!-- debut dialog -->
            <v-dialog v-model="dialog" max-width="80%">
                <template v-slot:activator="{ on }">
                    <v-layout align-start justify-end>
                        <v-btn style="min-width: 0; margin-bottom:0; margin-top:0"
                               color="primary" small dark
                               v-on="on"
                               @click="openDialong">
                            {{$storeCandidature.langueFormulaire == 'en' ? 'Add' : 'Ajouter'}}
                        </v-btn>
                    </v-layout>
                </template>
                <v-card>
                    <v-toolbar color="cyan darken-4" dark>
                        <v-toolbar-title>{{$storeCandidature.langueFormulaire == 'en' ? 'My diplomas :' : 'Ajouter un parcours scolaire :'}}</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <v-container grid-list-md>
                            <v-layout row wrap>
                                <h3>{{$storeCandidature.langueFormulaire == 'en' ? 'Post High School Studies' : 'Etudes :'}}</h3>
                                <hr size="5" width="100%" color="secondary" class='mb-2'>
                            </v-layout>
                            <v-layout row wrap xs12>
                                <v-flex xs4 v-if="$storeCandidature.sasCandidature.Ecole
                                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational">
                                    <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.AnneeScolaireList"
                                                    v-model="editedItem.AnneeScolairePostBac"
                                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Academic Year' : 'Année scolaire'"
                                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                                    item-value="Id"
                                                    return-object
                                                    chips
                                                    deletable-chips>
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex xs4>
                                    <v-layout row wrap xs12>
                                        <v-flex :class="{xs6 : !editedItem.EtablissementPostBac}" v-if="!editedItem.EtablissementAutre">
                                            <v-autocomplete class="pt-1" :items="$storeCandidature.etablissementFrequenteList"
                                                            v-model="editedItem.EtablissementPostBac"
                                                            :label="$storeCandidature.langueFormulaire == 'en' ? 'Institution name' : 'Etablissement fréquenté'"
                                                            item-text="Label"
                                                            :search-input.sync="search"
                                                            :placeholder="$storeCandidature.langueFormulaire == 'en' ? 'Enter the name of the institution.' : 'Saisissez le nom de l\'établissement.'"
                                                            @change="$storeCandidature.candidatureChanged = true"
                                                            @keyup="debounceInput"
                                                            :loading="isLoading"
                                                            item-value="Id"
                                                            return-object
                                                            chips
                                                            deletable-chips>
                                                <template #no-data>
                                                    <div v-if="search == null || search == ''" class="pt-2 pb-2 pl-2">{{$storeCandidature.langueFormulaire == 'en' ? 'Enter the name of the institution.' : 'Saisissez le nom de l\'établissement.'}}</div>
                                                    <div v-else class="pt-2 pb-2 pl-2">{{$storeCandidature.langueFormulaire == 'en' ? 'No results found' : 'Aucun établissment trouvé'}}</div>
                                                </template>
                                            </v-autocomplete>
                                        </v-flex>
                                        <v-flex :class="{xs6 : !editedItem.EtablissementAutre}" v-if="!editedItem.EtablissementPostBac">
                                            <v-text-field v-model="editedItem.EtablissementAutre"
                                                          :label="$storeCandidature.langueFormulaire == 'en' ? 'Institution name (If not in the list)' : 'Etablissement (Si pas dans la liste)'">
                                            </v-text-field>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                                <v-flex xs4 class="pl-5" v-if=" $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireBachelorsBba
                                       && ($storeCandidature.sasCandidature.Ecole && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIum
                                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational)">
                                    <v-switch :label="$storeCandidature.langueFormulaire == 'en' ? 'Repetition' : 'Redoublement'" v-model="editedItem.RedoublementPostBac"></v-switch>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap xs12>
                                <v-flex xs4 v-if="$storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational">
                                    <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.NiveauEtudesParcoursList"
                                                    v-model="editedItem.NiveauEtudes"
                                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Level of studies' : 'Niveau d\'études'"
                                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                                    item-value="Id"
                                                    v-on:change="chargerListeTypeEtudes(true)"
                                                    return-object
                                                    chips
                                                    deletable-chips>
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex xs4 v-if=" $storeCandidature.sasCandidature.Ecole && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIum
                                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational">
                                    <v-autocomplete class="pt-0" :items="typeEtudesParcoursList"
                                                    v-model="editedItem.TypeEtudes"
                                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Type of studies' : 'Type d\'études'"
                                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                                    item-value="Id"
                                                    v-on:change="chargerSpecialiteEtudes(true)"
                                                    return-object
                                                    chips
                                                    deletable-chips>
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex xs4 v-if="$storeCandidature.sasCandidature.Ecole
                                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireBachelorsBba
                                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational
                                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIum">
                                    <v-autocomplete class="pt-0" :items="specialiteParcoursList"
                                                    v-model="editedItem.SpecialiteEtudes"
                                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Speciality of studies' : 'Spécialité d\'études'"
                                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                                    item-value="Id"
                                                    return-object
                                                    chips
                                                    deletable-chips>
                                    </v-autocomplete>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap xs12>
                                <v-flex xs4 v-if=" $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireBachelorsBba ">
                                    <v-text-field v-model="editedItem.DiplomeObtenu" :label="$storeCandidature.langueFormulaire == 'en' ? 'Title of degree' : 'Diplôme obtenu'">
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs4 v-if="$storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireBachelorsBba">
                                    <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.AnneeObtentionList"
                                                    v-model="editedItem.AnneeDiplome"
                                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Year of graduation' : 'Année d\'obtention'"
                                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                                    item-value="Id"
                                                    return-object
                                                    chips
                                                    deletable-chips>
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex xs4 v-if="$storeCandidature.sasCandidature.Ecole && $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleInternational">
                                    <v-autocomplete class="pt-0" :items="$storeCandidature.configurationClient.PaysList"
                                                    :label="$storeCandidature.langueFormulaire == 'en' ? 'Country' : 'Pays'"
                                                    v-model="editedItem.Pays"
                                                    :item-text="$storeCandidature.langueFormulaire == 'en' ? 'Lang01' : 'Lang00'"
                                                    item-value="Id"
                                                    return-object
                                                    chips
                                                    deletable-chips
                                                    @change="$storeCandidature.candidatureChanged = true">
                                    </v-autocomplete>
                                </v-flex>
                                <v-flex xs4 v-if="$storeCandidature.sasCandidature.Ecole
                                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireBachelorsBba
                                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIum">
                                    <v-text-field v-model="editedItem.NoteMentionObtenue"
                                                  label="Note / Mention">
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <!--Caché pour l'Ece-->
                            <v-layout row wrap xs12 v-if="$storeCandidature.sasCandidature.Ecole
                                      && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleEce
                                      && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational
                                      && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIum">
                                <v-flex xs4 class="pl-2">
                                    <v-switch :label="$storeCandidature.langueFormulaire == 'en' ? 'Interruption of studies' : 'Interruption d\'études'" v-model="editedItem.InterruptionEtudes"></v-switch>
                                </v-flex>
                                <v-flex xs4>
                                    <v-text-field v-model="editedItem.SiOuiCombienDeTemps"
                                                  :label="$storeCandidature.langueFormulaire == 'en' ? 'If yes, how long' : 'Si oui, combien de temps'">
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs2 class="pl-2" v-if=" $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireBachelorsBba
                                         && ($storeCandidature.sasCandidature.Ecole && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIum
                                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational)">
                                    <v-switch :label="$storeCandidature.langueFormulaire == 'en' ? 'Apprentissage' : 'Learning'" v-model="editedItem.Apprentissage"></v-switch>
                                </v-flex>
                            </v-layout>
                        </v-container>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="close">{{$storeCandidature.langueFormulaire == 'en' ? 'Cancel' : 'Annuler'}}</v-btn>
                        <v-btn color="blue darken-1" flat @click="save">{{$storeCandidature.langueFormulaire == 'en' ? 'Submit' : 'Valider'}}</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <!-- fin dialog -->
            <hr size="5" width="100%" color="secondary">
        </v-layout>
        <!--liste  : {{$storeCandidature.sasCandidature.ListeParcoursScolaire}}-->
        <!-- Début Parcours scolaire -->
        <v-data-table :headers="$storeCandidature.dataIdFormulaireCandidature == $storeCandidature.configurationClient.DescIdFormulaireBachelorsBba ? headersMini :
                      $storeCandidature.sasCandidature.Ecole && $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleIum ?  headersIum : 
                      $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleInternational ? headersInternational : 
                      headers"
                      :items="$storeCandidature.sasCandidature.ListeParcoursScolaire" class="elevation-1" disable-pagination hide-default-footer>
            <template v-slot:no-data>
                <v-alert v-if="$storeCandidature.langueFormulaire == 'en' " :value="true" color="grey lighten-3" icon="warning">
                    No lines added
                </v-alert>
                <v-alert v-else :value="true" color="grey lighten-3" icon="warning">
                    La liste est vide
                </v-alert>
            </template>
            <template v-slot:item={item}>
                <!--On n'affiche dans la liste que les parcours hors terminale (Bac) et non supprimé-->
                <tr v-if="!item.Supprimer && !item.AnneeTerminale">
                    <th v-if="$storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireBachelorsBba" class="text-xs-left">{{item.DiplomeObtenu}}</th>
                    <th v-if="$storeCandidature.sasCandidature.Ecole
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational" class="text-xs-left">
                        {{item.AnneeScolairePostBac ? ($storeCandidature.langueFormulaire == 'en' ? item.AnneeScolairePostBac.Lang01 : item.AnneeScolairePostBac.Lang00) : ''}}
                    </th>
                    <th class="text-xs-left">{{item.EtablissementPostBac ? item.EtablissementPostBac.Label : item.EtablissementAutre}}</th>
                    <th v-if="$storeCandidature.sasCandidature.Ecole
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational" class="text-xs-left">
                        {{item.NiveauEtudes ? ($storeCandidature.langueFormulaire == 'en' ? item.NiveauEtudes.Lang01 : item.NiveauEtudes.Lang00) : ''}}
                    </th>
                    <th v-if="$storeCandidature.sasCandidature.Ecole
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIum &&
                        $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational" class="text-xs-left">
                        {{item.TypeEtudes ? ($storeCandidature.langueFormulaire == 'en' ? item.TypeEtudes.Lang01 : item.TypeEtudes.Lang00) : ''}}
                    </th>
                    <th v-if="$storeCandidature.sasCandidature.Ecole
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireBachelorsBba
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIum &&
                        $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational " class="text-xs-left">
                        {{item.SpecialiteEtudes ? ($storeCandidature.langueFormulaire == 'en' ? item.SpecialiteEtudes.Lang01 : item.SpecialiteEtudes.Lang00) : ''}}
                    </th>
                    <th v-if="$storeCandidature.sasCandidature.Ecole
                        && $storeCandidature.dataIdFormulaireCandidature != $storeCandidature.configurationClient.DescIdFormulaireBachelorsBba
                        && $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleIum &&
                        $storeCandidature.sasCandidature.Ecole.Id != $storeCandidature.configurationClient.DataIdEcoleInternational">
                        <v-switch v-model="item.RedoublementPostBac" hide-details></v-switch>
                    </th>
                    <th v-if="$storeCandidature.sasCandidature.Ecole
                        && $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleInternational" class="text-xs-left">
                        {{item.AnneeDiplome ? ($storeCandidature.langueFormulaire == 'en' ? item.AnneeDiplome.Lang01 : item.AnneeDiplome.Lang00) : ''}}
                    </th>
                    <th v-if="$storeCandidature.sasCandidature.Ecole
                        && $storeCandidature.sasCandidature.Ecole.Id == $storeCandidature.configurationClient.DataIdEcoleInternational" class="text-xs-left">
                        {{item.Pays ? ($storeCandidature.langueFormulaire == 'en' ? item.Pays.Lang01 : item.Pays.Lang00) : ''}}
                    </th>
                    <th>
                        <v-icon small class="mr-2" @click="editItem(item)">edit</v-icon>
                        <v-icon small @click="deleteItem(item)">delete</v-icon>
                    </th>
                </tr>
            </template>
        </v-data-table>
        <!-- fin liste Parcours scolaire -->
    </div>
</template>
<script>
    import lodash from 'lodash';
    import { TIMEOUT_ETABLISSEMENT } from '../constants'

    export default {
        data() {
            return {
                // Réaffecter l'objet global pour forcer la maj en temps réel
                $storeCandidature: this.$storeCandidature,

                // Dialog et Header list
                dialog: false,

                // Liste déroulantes locales
                typeEtudesParcoursList: [],
                specialiteParcoursList: [],

                // Header de la liste
                headers: [
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Degree' : 'Diplôme', value: 'diplome' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Academic Year' : 'Année scolaire', value: 'anneScolaire' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Institution' : 'Etablissement', value: 'etablissement' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Level of studies' : 'Niveau d\'études', value: 'niveauEtudes' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Type of studies' : 'Type d\'études', value: 'typeEtudes' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Speciality of studies' : 'Spacialité d\'études', value: 'specialiteEtudes' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Repeat' : 'Redoubler', value: 'redoublement' },
                    { text: '', value: 'actions', sortable: false }
                ],
                // Header réduit de la liste de la liste
                headersMini: [
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Academic Year' : 'Année scolaire', value: 'anneScolaire' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Institution' : 'Etablissement', value: 'etablissement' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Level of studies' : 'Niveau d\'études', value: 'niveauEtudes' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Type of studies' : 'Type d\'études', value: 'typeEtudes' },
                    { text: '', value: 'actions', sortable: false }
                ],

                // Header réduit de la liste de la liste pour Ium
                headersIum: [
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Degree' : 'Diplôme', value: 'diplome' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Academic Year' : 'Année scolaire', value: 'anneScolaire' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Institution' : 'Etablissement', value: 'etablissement' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Level of studies' : 'Niveau d\'études', value: 'niveauEtudes' },
                    { text: '', value: 'actions', sortable: false }
                ],

                // Header réduit de la liste de la liste pour international
                headersInternational: [
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Degree' : 'Diplôme', value: 'diplome' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Institution' : 'Etablissement', value: 'etablissement' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Year of graduation' : 'Année d\'obtention', value: 'anneeDiplome' },
                    { text: this.$storeCandidature.langueFormulaire == 'en' ? 'Country' : 'Pays', value: 'pays' },
                    { text: '', value: 'actions', sortable: false }
                ],

                editedIndex: -1,
                editedItem: {
                    DiplomeObtenu: '',
                    AnneeDiplome: null,
                    NoteMentionObtenue: '',
                    InterruptionEtudes: false,
                    SiOuiCombienDeTemps: '',
                    RedoublementPostBac: false,
                    EtablissementPostBac: null,
                    EtablissementAutre: '',
                    NiveauEtudes: null,
                    TypeEtudes: null,
                    SpecialiteEtudes: null,
                    Apprentissage: false,
                    Supprimer: false
                },
                search: '',
                isLoading : false,
            }
        },

        methods: {

            openDialong() {
                // Netoyage des etablissement.
                this.$storeCandidature.etablissementFrequenteList = []
            },
            editItem(item) {
                // Récupérer l'objet à traiter
                this.editedIndex = this.$storeCandidature.sasCandidature.ListeParcoursScolaire.indexOf(item)
                this.editedItem = Object.assign({}, item)

                // Chargé les listes type et spéciliaté selont le type
                this.chargerListeTypeEtudes(false)
                this.chargerSpecialiteEtudes(false)
                this.pushEtablissement();

                // Lancer le popup
                this.dialog = true
            },

            deleteItem(item) {
                if (confirm(this.$storeCandidature.langueFormulaire == 'en' ? 'Are you sure you want to delete this item?' : 'Etes-vous sûr de vouloir supprimer cet élément ?')) {
                    this.editedIndex = this.$storeCandidature.sasCandidature.ListeParcoursScolaire.indexOf(item)
                    this.editedItem.Supprimer = true;
                    Object.assign(this.$storeCandidature.sasCandidature.ListeParcoursScolaire[this.editedIndex], this.editedItem)
                    this.$storeCandidature.candidatureChanged = true
                }
            },

            // Charger type d'études : Attendre le chargement d'une fiche ou le changement de la valeur deNiveau Etude
            chargerListeTypeEtudes(onChange) {
                this.typeEtudesParcoursList = []
                this.specialiteParcoursList = []

                if (onChange) {
                    this.editedItem.TypeEtudes = null
                    this.editedItem.SpecialiteEtudes = null
                }

                if (this.editedItem.NiveauEtudes) {
                    this.$storeCandidature.chargerFileData(this.$storeCandidature.configurationClient.DescIdTypeEtudes, '', '', this.editedItem.NiveauEtudes.Id, true, false)
                        .then(response => {
                            // Succés
                            if (response.data) {
                                this.typeEtudesParcoursList = response.data
                            }
                        })
                }
            },

            // Charger Spécialités: Attendre le chargement d'une fiche ou le changement de la valeur de Niveau Etude
            chargerSpecialiteEtudes(onChange) {
                this.specialiteParcoursList = []

                if (onChange) {
                    this.editedItem.SpecialiteEtudes = null
                }

                if (this.editedItem.TypeEtudes) {
                    this.$storeCandidature.chargerFileData(this.$storeCandidature.configurationClient.DescIdSpecialite, '', '', this.editedItem.TypeEtudes.Id, true, false)
                        .then(response => {
                            // Succés
                            if (response.data) {
                                this.specialiteParcoursList = response.data
                            }
                        })
                }
            },

            close() {
                this.dialog = false
                setTimeout(() => {
                    this.editedItem = Object.assign({},
                        {
                            DiplomeObtenu: '',
                            AnneeDiplome: null,
                            NoteMentionObtenue: '',
                            InterruptionEtudes: false,
                            SiOuiCombienDeTemps: '',
                            RedoublementPostBac: false,
                            EtablissementPostBac: null,
                            EtablissementAutre: '',
                            NiveauEtudes: null,
                            SpecialiteEtudes: null,
                            TypeEtudes: null,
                            Apprentissage: false,
                            Supprimer: false
                        })
                    this.editedIndex = -1
                }, 300)
            },

            save() {
                if (this.editedIndex > -1) {
                    Object.assign(this.$storeCandidature.sasCandidature.ListeParcoursScolaire[this.editedIndex], this.editedItem)
                } else {
                    this.$storeCandidature.sasCandidature.ListeParcoursScolaire.push(this.editedItem)
                }
                this.$storeCandidature.candidatureChanged = true
                this.close()
            },

            // Recherche des etablissements.
            debounceInput: lodash.debounce(async function () {

                // Afficher le chargement.
                this.isLoading = true

                if (this.$storeCandidature) {

                    await this.$storeCandidature.chargerListesEtablissementFrequente(this.search);

                    // Ne plus afficher.
                    this.isLoading = false
                }
            }, TIMEOUT_ETABLISSEMENT),

            // Push le EtablissementTerminale à la liste pour ne pas que l'utilisateur voit une valeur vide.
            pushEtablissement() {                                
                if (this.editedItem
                    && this.editedItem.EtablissementPostBac) {

                    // Ajout des valeurs déjà présentes dans le formulaire pour ne pas qu'elles dispairessent.
                    this.$storeCandidature.etablissementFrequenteList = [this.editedItem.EtablissementPostBac];
                }
            },
        },

        mounted() {
            if (this.$refs.etapeInfoSpplementaires) {
                this.$refs.etapeInfoSpplementaires.validate()
            }
        },
    }
</script>